import { render, staticRenderFns } from "./ClipboardCopy.vue?vue&type=template&id=ca7d4234&scoped=true&"
import script from "./ClipboardCopy.vue?vue&type=script&lang=js&"
export * from "./ClipboardCopy.vue?vue&type=script&lang=js&"
import style0 from "./ClipboardCopy.vue?vue&type=style&index=0&id=ca7d4234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7d4234",
  null
  
)

export default component.exports